import r from"@bedrock-layout/use-stateful-ref";import t from"react";function e(e){var u=r(null);return t.useEffect(function(){e&&("function"==typeof e?e(u.current):e.current=u.current)}),u}export{e as default};
//# sourceMappingURL=index.m.js.map
